<template>
  <div class="accordion-item">
    <div class="accordion-item-content" @click="itemClicked()">
      <!--  DESKTOP ACCORDION ROW -->
      <table v-if="global.screenWidth >= 1008" class="admin-table-structure">
        <tbody>
          <tr>
            <td>
              <div class="profilepicture">
                <!-- Replace div with img-->
              </div>
              <div class="organization-location">
                <span class="organization">{{item.organization}}</span>
                <span class="location">{{item.city}}</span>
              </div>
            </td>
            <td>{{item.requestId}}</td>
            {{moment(item.requestTimestamp).format('l')}}
            <td>{{`${item.masksCommitted}/${item.masks}`}}</td>
            <td>{{`${item.capsCommitted}/${item.caps}`}}</td>
            <td>{{`${item.otherCommitted}/${item.other}`}}</td>
            <td>
              <button
                v-if="item.requestStatus === statusConstants.request.pending"
                class="red"
                @click="denyRequestPopup(item)"
              >Deny</button>
              <button
                v-if="item.requestStatus === statusConstants.request.pending"
                class="green"
                @click="acceptRequestPopup(item)"
              >Accept</button>
            </td>
          </tr>
        </tbody>
      </table>
      <!--  MOBILE ACCORDION ROW -->
      <div v-else class="flex-col">
        <div class="organization-location">
          <span class="organization">Organization: {{item.organization}}</span>
        </div>

        <span class="mobile-table-row">
          <strong>Request #:</strong>
          {{item.requestId}}
        </span>
        <span class="mobile-table-row">
          <strong>Date Created:</strong>
          {{moment(item.requestTimestamp).format('l')}}
        </span>
        <span class="mobile-table-row">
          <strong>City Center:</strong>
          {{item.cityCenter}}
        </span>
        <span class="mobile-table-row">
          <strong>Masks/Caps/Other</strong>
        </span>
        <span class="mobile-table-row">{{item.masks}} / {{item.caps}} / {{item.other}}</span>
        <button
          v-if="item.requestStatus === statusConstants.request.pending"
          class="red"
          @click="denyRequestPopup(item)"
        >Deny</button>
        <button
          v-if="item.requestStatus === statusConstants.request.pending"
          class="green"
          @click="acceptRequestPopup(item)"
        >Accept</button>
      </div>
    </div>
    <!--  Dropdown container -->
    <div :id="itemId" class="description-container">
      <button v-if="changesExist" class="green" @click="sendRequestUpdates()">Save Changes</button>
      <button
        v-if="changesExist"
        class="green"
        @click="formValues = item; changesExist = false;"
      >Reset</button>

      <div class="description-content">
        <div class="container-row">
          <div class="flex-col organization-col">
            <div class="item-group">
              <div class="item-label">
                Organization
                <div v-if="errors.organization" class="error">***</div>
              </div>
              <input
                v-on:change="changesExist = true"
                class="form-value form-title"
                :placeholder="'Organization'"
                v-model="formValues.organization"
                type="text"
              />
            </div>
            <div class="item-group">
              <div class="item-label">Primary Contact</div>
              <div class="flex-col">
                <input
                  v-on:change="changesExist = true"
                  class="form-value"
                  :placeholder="'First Name'"
                  v-model="formValues.firstName"
                  type="text"
                />
                <div v-if="errors.firstName" class="error">***</div>

                <input
                  v-on:change="changesExist = true"
                  class="form-value"
                  :placeholder="'Last Name'"
                  v-model="formValues.lastName"
                  type="text"
                />
                <div v-if="errors.lastName" class="error">***</div>

                <input
                  v-on:change="changesExist = true"
                  class="form-value"
                  :placeholder="'Email'"
                  v-model="formValues.email"
                  type="text"
                />
                <div v-if="errors.email" class="error">***</div>

                <input
                  v-on:change="changesExist = true"
                  class="form-value"
                  :placeholder="'Phone Number'"
                  v-model="formValues.phoneNumber"
                  type="text"
                />
                <div v-if="errors.phoneNumber" class="error">***</div>
              </div>
            </div>
            <div class="item-group">
              <div class="item-label">Shipping Address</div>
              <div class="flex-col">
                <input
                  v-on:change="changesExist = true"
                  class="form-value"
                  :placeholder="'Address Line 1'"
                  v-model="formValues.addressLine1"
                  type="text"
                />
                <div v-if="errors.addressLine1" class="error">***</div>

                <input
                  v-on:change="changesExist = true"
                  class="form-value"
                  :placeholder="'Address Line 2'"
                  v-model="formValues.addressLine2"
                  type="text"
                />
                <input
                  v-on:change="changesExist = true"
                  class="form-value"
                  :placeholder="'Province / State'"
                  v-model="formValues.provinceState"
                  type="text"
                />
                <div v-if="errors.provinceState" class="error">***</div>
                <input
                  v-on:change="changesExist = true"
                  class="form-value"
                  :placeholder="'City / Town'"
                  v-model="formValues.cityTown"
                  type="text"
                />
                <div v-if="errors.cityTown" class="error">***</div>

                <input
                  v-on:change="changesExist = true"
                  class="form-value"
                  :placeholder="'Postal Code'"
                  v-model="formValues.postalCode"
                  type="text"
                />
                <div v-if="errors.postalCode" class="error">***</div>
              </div>
            </div>
            <div v-if="global.screenWidth >= 1008" class="item-group">
              <div class="item-label">Current Status:</div>

              <Dropdown
                :className="'dashboard-dd'"
                :options="requestStatusList"
                :initialItem="requestStatusList.find( (status) => status.key === item.requestStatus)"
                @itemselected="(newStatus) => setEditedField('requestStatus', newStatus.key)"
              />
            </div>
          </div>
          <div class="flex-col request-details-col">
            <div class="section-label">Request Details</div>
            <div class="f-row flex-wrap ppe-items">
              <div class="ppe-item">
                <div class="quantity">
                  <b>{{item.masksCommitted}}</b>
                  /
                  <input
                    v-on:change="changesExist = true"
                    :placeholder="0"
                    v-model="formValues.masks"
                    class="numberinput"
                    type="number"
                    min="0"
                  />
                </div>
                <div class="title">
                  Masks
                  <div
                    v-if="errors.masks"
                    class="error"
                  >{{typeof errors.masks === 'string' ? errors.masks : '***'}}</div>
                </div>
              </div>
              <div class="ppe-item">
                <div class="quantity">
                  <b>{{item.capsCommitted}}</b>
                  /
                  <input
                    v-on:change="changesExist = true"
                    :placeholder="0"
                    v-model="formValues.caps"
                    class="numberinput"
                    type="number"
                    min="0"
                  />
                </div>
                <div class="title">
                  Caps
                  <div
                    v-if="errors.caps"
                    class="error"
                  >{{typeof errors.caps === 'string' ? errors.caps : '***'}}</div>
                </div>
              </div>
              <div class="ppe-item">
                <div class="quantity">
                  <b>{{item.otherCommitted}}</b>
                  /
                  <input
                    v-on:change="changesExist = true"
                    :placeholder="0"
                    v-model="formValues.other"
                    class="numberinput"
                    type="number"
                    min="0"
                  />
                </div>
                <div class="title">
                  Other
                  <div
                    v-if="errors.other"
                    class="error"
                  >{{typeof errors.other === 'string' ? errors.other : '***'}}</div>
                </div>
              </div>
            </div>

            <div class="f-row notes-container">
              <div class="item-group additional-notes">
                <div class="item-label">Additional Notes</div>
                <div class="form-value">
                  <textarea
                    v-on:change="changesExist = true"
                    :placeholder="'Additional Notes'"
                    v-model="formValues.additionalNotes"
                    type="text"
                    maxlength="300"
                  />
                </div>
              </div>
              <div class="item-group additional-notes">
                <div class="item-label">Admin Notes</div>
                <div class="form-value">
                  <textarea
                    v-on:change="changesExist = true"
                    :placeholder="'Admin notes'"
                    v-model="formValues.adminNotes"
                    type="text"
                    maxlength="300"
                  />
                </div>
              </div>
            </div>
            <div v-if="global.screenWidth < 1008" class="item-group">
              <div class="item-label">Current Status:</div>

              <Dropdown
                :className="'dashboard-dd'"
                :options="requestStatusList"
                :initialItem="requestStatusList.find( (status) => status.key === item.requestStatus)"
                @itemselected="(newStatus) => setEditedField('requestStatus', newStatus.key)"
              />
              <button v-if="changesExist" class="green" @click="sendRequestUpdates()">Save Changes</button>
              <button
                v-if="changesExist"
                class="green"
                @click="formValues = item; changesExist = false;"
              >Reset</button>
            </div>
          </div>
        </div>
        <CommitmentTable
          v-if="item.requestStatus != statusConstants.request.pending"
          :items="item.commitments"
          :request="item"
        />
      </div>
    </div>
  </div>
</template>

<script>
import fire from "@/config/fire.js";
import axios from "axios";
import { mapActions, mapState } from "vuex";
import CommitmentTable from "@/components/global/Accordion/AccordionTypes/CommitmentTable";
import Dropdown from "@/components/global/Dropdown";
import { statusConstants } from "@/data/statusConstants";
import { validationHelper } from "@/helpers";
import moment from "moment";
export default {
  name: "AdminItem",
  components: {
    CommitmentTable,
    Dropdown,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    itemId: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState(["global"]),
  },
  data() {
    return {
      requestStatusList: Object.keys(statusConstants().request).map(
        (status) => {
          return { label: status, key: status };
        }
      ),
      formValues: {},
      changesExist: false,
      statusConstants: statusConstants(),
      errors: {},
    };
  },
  mounted() {
    this.formValues = JSON.parse(JSON.stringify(this.item));
  },
  methods: {
    moment(date) {
      return moment(date);
    },
    itemClicked() {
      this.$emit("clickCallback", this.itemId);
    },
    denyRequest(item) {
      if (!item.requestId) {
        this.$swal("Error!", "Please try again later", "error");
      }

      // fire.auth().onAuthStateChanged(user => {
      this.getFireIdToken()
        .then((idToken) => {
          if (!idToken) return;
          axios.defaults.headers.common["Authorization"] = idToken;
          const url = process.env.VUE_APP_BASE_URL + "/api/denyRequest";
          return axios({
            method: "post",
            url: url,
            headers: { Authorization: idToken },
            data: {
              requestId: item.requestId,
            },
          });
        })
        .then((res) => {
          if (res.data && res.data.status === "success") {
            this.setUserData(res.data.userData);
            this.$swal("Success!", "You have denied the request!", "success");
          } else {
            this.$swal("Error!", "Please try again later", "error");
          }
        });
      // });
    },
    denyRequestPopup(item) {
      this.$swal({
        title: "Confirm Deny",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          this.denyRequest(item);
        }
      });
    },
    acceptRequestPopup(item) {
      this.$swal({
        title: "Confirm Accept",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          this.acceptRequest(item);
        }
      });
    },
    acceptRequest(item) {
      if (!item.requestId) {
        this.$swal("Error!", "Please try again later", "error");
      }

      // fire.auth().onAuthStateChanged(user => {
      this.getFireIdToken()
        .then((idToken) => {
          if (!idToken) return;
          axios.defaults.headers.common["Authorization"] = idToken;
          const url = process.env.VUE_APP_BASE_URL + "/api/acceptRequest";
          return axios({
            method: "post",
            url: url,
            headers: { Authorization: idToken },
            data: {
              requestId: item.requestId,
            },
          });
        })
        .then((res) => {
          if (res.data && res.data.status === "success") {
            this.setUserData(res.data.userData);
            this.$swal("Success!", "You have accepted the request!", "success");
          } else {
            this.$swal("Error!", "Please try again later", "error");
          }
        });
      // });
    },
    sendRequestUpdates() {
      const item = this.item;
      this.errors = {};
      if (!item.requestId) {
        this.$swal("Error!", "Please try again later", "error");
        return;
      }
      if (this.checkEmpties()) {
        this.$swal(
          "Error!",
          "Please correct the indicated field(s) and try your submission again.",
          "error"
        );
        return;
      }

      // fire.auth().onAuthStateChanged(user => {
      this.getFireIdToken()
        .then((idToken) => {
          if (!idToken) return;
          axios.defaults.headers.common["Authorization"] = idToken;
          const url = process.env.VUE_APP_BASE_URL + "/api/updateRequest";
          return axios({
            method: "post",
            url: url,
            headers: { Authorization: idToken },
            data: {
              requestId: item.requestId,
              formValues: this.formValues,
            },
          });
        })
        .then((res) => {
          if (res.data && res.data.status === "success") {
            this.changesExist = false;
            this.setUserData(res.data.userData);
            this.$swal({
              title: "Success!",
              text: "You have updated the request!",
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Okay",
            }).then((result) => {
              this.$emit("closeAccordion");
            });
          } else {
            this.$swal("Error!", "Please try again later", "error");
          }
        });
      // });
    },
    setEditedField(fieldName, value) {
      this.changesExist = true;
      this.formValues[fieldName] = value;
    },
    getFireIdToken() {
      return fire.auth().currentUser.getIdToken();
    },
    checkEmpties() {
      let emptiesExist = false;

      if (
        !this.formValues.firstName ||
        this.formValues.firstName.trim() === ""
      ) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          firstName: true,
        };
      }
      if (!this.formValues.lastName || this.formValues.lastName.trim() === "") {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          lastName: true,
        };
      }
      if (
        !this.formValues.organization ||
        this.formValues.organization.trim() === ""
      ) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          organization: true,
        };
      }
      if (
        !this.formValues.email ||
        this.formValues.email.trim() === "" ||
        !validationHelper.validateEmail(this.formValues.email)
      ) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          email: true,
        };
      }
      if (
        !this.formValues.phoneNumber ||
        this.formValues.phoneNumber.trim() === "" ||
        !validationHelper.validatePhone(this.formValues.phoneNumber)
      ) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          phoneNumber: true,
        };
      }
      if (
        !this.formValues.addressLine1 ||
        this.formValues.addressLine1.trim() === ""
      ) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          addressLine1: true,
        };
      }
      if (
        !this.formValues.provinceState ||
        this.formValues.provinceState.trim() === ""
      ) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          provinceState: true,
        };
      }
      if (!this.formValues.cityTown || this.formValues.cityTown.trim() === "") {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          cityTown: true,
        };
      }
      if (
        !this.formValues.postalCode ||
        this.formValues.postalCode.trim() === ""
      ) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          postalCode: true,
        };
      }
      if (
        !this.formValues.cityCenter ||
        this.formValues.cityCenter.trim() === ""
      ) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          cityCenter: true,
        };
      }
      if (
        this.formValues.masks === 0 &&
        this.formValues.caps === 0 &&
        this.formValues.other === 0
      ) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          masks: true,
          caps: true,
          other: true,
        };
      }
      // if (this.formValues.masks > 200 || this.formValues.masks < 0) {
      //   emptiesExist = true;
      //   this.errors = {
      //     ...this.errors,
      //     masks: "Qty cannot be over 200, or negative."
      //   };
      // }
      // if (this.formValues.caps > 200 || this.formValues.caps < 0) {
      //   emptiesExist = true;
      //   this.errors = {
      //     ...this.errors,
      //     caps: "Qty cannot be over 200, or negative."
      //   };
      // }
      // if (this.formValues.other > 200 || this.formValues.other < 0) {
      //   emptiesExist = true;
      //   this.errors = {
      //     ...this.errors,
      //     other: "Qty cannot be over 200, or negative."
      //   };
      // }
      return emptiesExist;
    },
    ...mapActions(["setUserData"]),
  },
};
</script>

<style lang="scss" scoped>
.error {
  color: red !important;
}
.accordion-item {
  color: black !important;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  box-shadow: 0 0 0 0 rgba(140, 136, 150, 0.3);
  transition: all 0.2s ease-in-out;
  &:hover {
    box-shadow: 0 19px 38px 0 rgba(140, 136, 150, 0.3);
    z-index: 2;
  }
  .accordion-item-content {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    background: #fff;
    border-bottom: 1px solid #efefef;
    span {
      font-size: 15px;
      line-height: 15px;
      text-transform: uppercase;
      color: #000;
    }
    button {
      color: #fff;
      border-radius: 5px;
    }
    .profilepicture {
      height: 23px;
      width: 23px;
      border-radius: 50%;
      background: linear-gradient(to right, #20356d, #d83cb4);
      float: left;
      @media (max-width: $md) {
        display: none;
      }
    }
    .organization-location {
      display: flex;
      flex-direction: column;
      .organization {
        font-size: 14px;
        color: #8b8795;
        letter-spacing: 0;
        margin-left: 7px;
        @media (max-width: $sm) {
          margin-left: 0;
        }
      }
      .location {
        opacity: 0.7;
        font-size: 14px;
        color: #8b8795;
        letter-spacing: 0;
        margin-left: 7px;
        @media (max-width: $sm) {
          margin-left: 0;
        }
      }
    }
  }
  .downArrow {
    justify-self: flex-end;
    font-size: 20px;
    color: #000;
    margin-right: 25px;
    margin-left: 4px;
    height: 100%;
    display: flex;
    align-items: center;
    align-self: center;
    @media (max-width: $xl) {
      font-size: 1rem;
      color: #ffffff;
    }
    .fa-chevron-down {
      transform: rotate(0deg);
      transition-duration: 0.3s;
    }
    .fa-chevron-down.rotate {
      transform: rotate(180deg);
      transition-duration: 0.3s;
    }
  }
  .title {
    display: flex;
    align-items: center;
    justify-content: left;
    width: 100%;
  }
  .description-container {
    height: 0;
  }
  .description {
    height: 100%;
    font-size: 14px;
    color: #000000;
    .bold {
    }
  }
  .description-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #ffffff;
    border-bottom: 1px solid #efefef;
    padding: 24px 20px;
    .description {
      max-width: 625px;
    }
    @media (max-width: $lg) {
      padding: 15px 25px;
    }
    @media (max-width: $md) {
      padding: 5px 15px;
    }
    input {
      margin: 5px 0;
      border: 0;
    }
    textarea {
      width: 100%;
      height: 200px;
      border: 0;
    }
    .numberinput {
      width: 100px;
    }
  }

  .container-row {
    display: flex;
    flex-direction: row;
    width: 100%;
    @media (max-width: $md) {
      flex-direction: column;
    }
  }
  .flex-col {
    display: flex;
    flex-direction: column;
    span.mobile-table-row {
      font-size: 14px;
      margin: 7px 0 7px 15px;
      strong {
        color: #8b8795;
      }
    }
  }
  .flex-row,
  .f-row {
    display: flex;
    flex-direction: row;
  }
  .flex-center {
    justify-content: center;
    align-items: center;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .flex-grow {
    flex-grow: 1;
  }
  .notes-container {
    @media (max-width: $md) {
      flex-direction: column;
    }
  }
  .ppe-items {
    width: 500px;
    max-width: 100%;
    justify-content: space-between;
    @media (max-width: $lg) {
      justify-content: inherit;
    }
    @media (max-width: $md) {
      flex-direction: column;
    }
    .ppe-item {
      margin: auto;
      @media (max-width: $lg) {
        margin: auto 12px;
      }
      @media (max-width: $md) {
        margin: auto;
      }
      .quantity {
        font-size: 33px;
        color: #003900;
        letter-spacing: 0px;
        line-height: 40px;
        @media (max-width: $lg) {
          font-size: 26px;
        }
        @media (max-width: $md) {
          font-size: 22px;
        }
        b {
          color: #2ec693;
        }
      }
      .title {
        opacity: 0.5;
        font-size: 14px;
        color: #8b8795;
        letter-spacing: 0;
      }
    }
  }

  .organization-col {
    max-width: 320px;
    border-right: 1px solid #efefef;
    padding: 0 25px;
    @media (max-width: $md) {
      padding: 0;
      border-right: none;
    }
  }
  .request-details-col {
    flex-grow: 1;
    padding-left: 35px;
    @media (max-width: $md) {
      padding-left: 0;
      margin-top: 25px;
    }
  }

  .item-group {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0 15px 0 0;
    margin-top: 35px;
    @media (max-width: $md) {
      padding: 8px;
    }
    &.additional-notes {
      @media (min-width: $md) {
        &:first-child {
          border-right: 1px solid #efefef;
        }
        &:nth-child(2) {
          padding: 0 8px 0 35px;
        }
      }
    }
  }
  .item-label {
    opacity: 0.7;
    font-size: 14px;
    color: #8b8795;
    letter-spacing: 0;
    margin-top: 25px;
  }
  .form-value {
    font-size: 14px;
    color: #8b8795;
    letter-spacing: 0;
    line-height: 20px;
    &.form-title {
      font-size: 18px;
    }
  }
  .section-label {
    opacity: 0.5;
    font-size: 14px;
    color: #8b8795;
    letter-spacing: 0;
  }
}
.downArrow {
  justify-self: flex-end;
  font-size: 23px;
  color: #000 !important;
  margin-right: 25px;
  margin-left: 4px;
  height: 100%;
  display: flex;
  align-items: center;
  align-self: center;
  img {
    transform: rotate(0deg);
    transition-duration: 0.3s;
    @media (max-width: $lg) {
      height: 7px;
      width: 7px;
    }
  }
  img.rotate {
    transform: rotate(180deg);
    transition-duration: 0.3s;
  }
}
</style>
<style lang="scss">
.accordion-item {
  .description {
    span {
      color: red;
      &.bold {
        color: #000;
      }
    }
    .link {
      color: #000;
      cursor: pointer;
    }
  }
  .edit-btn {
    margin: 20px 0 0 20px !important;
    color: #fff;
  }
  .btn-secondary {
    color: #fff;
    background-color: #e4aad6;
    border-color: #20356d;
    &.dropdown-toggle {
      background-color: #d83cb4;
    }
  }
  .dropdown-component .dd-title {
    color: #fff;
    font-family: "Montserrat", sans-serif !important;
  }
}
</style>